var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFormSetting(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33337 17.1536V4.65365C3.33337 4.10111 3.55287 3.57121 3.94357 3.18051C4.33427 2.78981 4.86417 2.57031 5.41671 2.57031H16.6667V19.237H5.41671C4.86417 19.237 4.33427 19.0175 3.94357 18.6268C3.55287 18.2361 3.33337 17.7062 3.33337 17.1536ZM3.33337 17.1536C3.33337 16.6011 3.55287 16.0712 3.94357 15.6805C4.33427 15.2898 4.86417 15.0703 5.41671 15.0703H16.6667",
    stroke: "#67768E",
    strokeWidth: 1.1842,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66663 6.73438H11.6666",
    stroke: "#67768E",
    strokeWidth: 1.1842,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66663 10.0703H13.3333",
    stroke: "#67768E",
    strokeWidth: 1.1842,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormSetting);
export default __webpack_public_path__ + "static/media/FormSetting.7ba8f76f0732c6638a3e65ae7a57a24f.svg";
export { ForwardRef as ReactComponent };